module.exports = __webpack_public_path__ + "static/media/Raleway-Regular.75b4247f.ttf";